declare namespace $ {

	type $shm_hitalama_hovered__hovered_shm_hitalama_map_page_dragger_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_dragger['hovered'] >
		,
		ReturnType< $shm_hitalama_hovered['hovered'] >
	>
	type $shm_hitalama_keepsize__zoom_shm_hitalama_map_page_dragger_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_dragger['zoom'] >
		,
		ReturnType< $shm_hitalama_keepsize['zoom'] >
	>
	type $shm_hitalama_keepsize__min_zoom_shm_hitalama_map_page_dragger_3 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_keepsize['min_zoom'] >
	>
	type $shm_hitalama_keepsize__anchor_hor_shm_hitalama_map_page_dragger_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_dragger['anchor_hor'] >
		,
		ReturnType< $shm_hitalama_keepsize['anchor_hor'] >
	>
	type $shm_hitalama_keepsize__anchor_vert_shm_hitalama_map_page_dragger_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_dragger['anchor_vert'] >
		,
		ReturnType< $shm_hitalama_keepsize['anchor_vert'] >
	>
	export class $shm_hitalama_map_page_dragger extends $mol_button_minor {
		Icon_1( ): $mol_icon_dots_vertical
		Icon_2( ): $mol_icon_dots_vertical
		pointerdown( next?: any ): any
		hovered( next?: boolean ): boolean
		Hovered( ): $shm_hitalama_hovered
		Keepsize( ): $shm_hitalama_keepsize
		zoom_for_dragger( ): number
		top( ): string
		left( ): string
		Map_page( ): $shm_hitalama_map_page
		sub( ): readonly(any)[]
		event( ): ({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_page_dragger['pointerdown'] > ): ReturnType< $shm_hitalama_map_page_dragger['pointerdown'] >,
		})  & ReturnType< $mol_button_minor['event'] >
		plugins( ): readonly(any)[]
		x( ): number
		y( ): number
		anchor_hor( next?: string ): string
		anchor_vert( next?: string ): string
		zoom( ): ReturnType< $shm_hitalama_map_page_dragger['zoom_for_dragger'] >
		widget( next?: any ): any
		set_pos( ): any
		style( ): ({ 
			'top': ReturnType< $shm_hitalama_map_page_dragger['top'] >,
			'left': ReturnType< $shm_hitalama_map_page_dragger['left'] >,
		})  & ReturnType< $mol_button_minor['style'] >
	}
	
}

//# sourceMappingURL=dragger.view.tree.d.ts.map